import {useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ApiRequest from "../../../helper/ApiRequest";
import { ApiEndpoints } from "../../../helper/ApiEndpoints";
import DataTable from "../../../component/DataTable";
import { toast } from "react-toastify";
import AdminHeader from "../../../component/AdminHeader";

const categoryListEndpoint = ApiEndpoints.productCategory.categoryList;
const categoryDeleteEndpoint = ApiEndpoints.productCategory.categoryDelete;
const editPath = "edit-product-category";
const tableHeader = ["Date","Name", "slug"];
const tbody = ["createdAt","name", "slug"];

export default function ProductcatList() {
  const [data, setData] = useState([]);

  const dataFetch = async () => {
      try {
        const response = await ApiRequest("GET", categoryListEndpoint);
        const result = response.product_categories;
        setData(result);
      } catch (error) {
        console.log(error);
      }
    };

  useEffect(() => {
    dataFetch();
  }, []);

  const handleDelete = async (productcategory_id) => {
      const payload = { productcategory_id };
      try {
        const response = await ApiRequest("POST", categoryDeleteEndpoint, payload);
        toast.success(response.message);
        dataFetch();
      } catch (error) {
        console.log(error);
      }
    };

    const pagename = {
      name: 'Product Management',
      user: 'Admin',
      innerpage: 'Product Management / Category'
    }

  return (
    <>
    <AdminHeader pagename={pagename}/>

      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-product-category">Add +</Link>
        <DataTable
            data={data}
            tableHeader={tableHeader}
            tbody={tbody}
            editPath={editPath}
            onDelete={handleDelete}
        />
      </div>
    </>
  );
}
